
import { IMonTuongDuongActionTypes } from "../../action-types/category/IMonTuongDuongActions";
import { IMonTuongDuongReducer } from "../../reducer-model/category/IMonTuongDuongReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IMonTuongDuongReducer = {
  status: eReducerStatusBase.is_not_initialization,
  monTuongDuongs: [],
  selectedIds:[],
  filter: {
    id_he: 0,
  },
};
export const monTuongDuongReducer = (
  state: IMonTuongDuongReducer = iniState,
  action: IMonTuongDuongActionTypes
): IMonTuongDuongReducer => {
  switch (action.type) {
    case "MON_TUONG_DUONG_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MON_TUONG_DUONG_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        monTuongDuongs: action.payload,
      };
    case "MON_TUONG_DUONG_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_TUONG_DUONG_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        monTuongDuongEditing: action.payload
      };
    case "MON_TUONG_DUONG_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "MON_TUONG_DUONG_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MON_TUONG_DUONG_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "MON_TUONG_DUONG_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_TUONG_DUONG_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MON_TUONG_DUONG_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MON_TUONG_DUONG_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_TUONG_DUONG_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    case "MON_TUONG_DUONG_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload
      };
    default:
      return state;
  }
};
